import vxThumbnailViewer from '../components/b2c/pdp/vx-thumbnail-viewer/vx-thumbnail-viewer.vue';
import vxPdpProductInfo from '../components/b2c/pdp/vx-pdp-product-info/vx-pdp-product-info.vue';
import vxTabContainer from '../components/b2c/pdp/vx-tab-container/vx-tab-container.vue';

const pdpModule = {
  components: {
    vxThumbnailViewer,
    vxPdpProductInfo,
    vxTabContainer,
  },
};

export default pdpModule;



// WEBPACK FOOTER //
// ./src/modules/pdp-b2c.js